import React from "react";
import { X, CheckCircle, Smartphone } from "lucide-react";

/**
 * PaymentSuccessModal - Modal shown after successful payment method addition
 * Tells users to navigate back to their app and login
 */
const PaymentSuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] text-white p-6 rounded-t-2xl relative">
          <h2 className="text-2xl font-bold text-center">Payment Method Saved!</h2>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors p-1 rounded-full hover:bg-white/20"
            aria-label="Close modal"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="text-center mb-6">
            <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Your payment method has been saved successfully!
            </h3>
          </div>

          <div className="bg-gradient-to-r from-cyan-50 to-teal-50 border border-cyan-200 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <Smartphone className="w-6 h-6 text-cyan-600 mt-1 flex-shrink-0" />
              <div>
                <p className="text-sm font-semibold text-gray-900 mb-2">
                  Next Steps:
                </p>
                <p className="text-sm text-gray-700">
                  Please navigate back to your IzzyAI app and log in to continue using the service.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <button
              onClick={onClose}
              className="w-full bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] text-white font-semibold py-3 px-6 rounded-full transition-all duration-300 hover:opacity-90 hover:scale-105"
            >
              Got it!
            </button>
            <p className="text-xs text-center text-gray-500">
              You can now close this page and return to the app
            </p>
          </div>
        </div>

        {/* Footer Info */}
        <div className="bg-gray-50 p-4 rounded-b-2xl text-center">
          <p className="text-xs text-gray-500">
            Need help? Contact us at <strong>support@izzyai.com</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessModal;

